import React, { createContext, useCallback, useState } from 'react';

export const NotificationContext = createContext({
  notifications: [],
  // eslint-disable-next-line
  addNotification: (n) => { },
  // eslint-disable-next-line
  removeNotification: (n) => { },
  clearNotifications: () => { }
});

function NotificationContextProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [isForceCleared, setIsForceCleared] = useState(false);

  // Add new notification
  const addNotification = useCallback(
    (n) => {
      if (isForceCleared) return;

      const index = notifications.findIndex(m => m.type === n.type);
      if (index === -1) {
        setNotifications([...notifications, n]);
      }
    },
    [notifications.length, setNotifications, isForceCleared]
  );

  // Remove a notification
  const removeNotification = useCallback(
    (n) => {
      const index = notifications.findIndex(m => m.type === n.type);
      if (index !== -1) {
        const _notifications = [...notifications];
        _notifications.splice(index, 1);
        setNotifications(_notifications);
      }
    },
    [notifications.length, setNotifications]
  );

  // Clear notifications
  const clearNotifications = useCallback(
    () => {
      setNotifications([]);
      setIsForceCleared(true);

      // setTimeout(() => {
      //   setIsForceCleared(false);
      // }, [10000]);
    },
    [setNotifications, setIsForceCleared]
  );

  const contextData = {
    notifications,
    addNotification,
    removeNotification,
    clearNotifications
  }

  return (
    <NotificationContext.Provider value={contextData}>
      {children}
    </NotificationContext.Provider>
  )
}

export { NotificationContextProvider };